exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#ServiceAgreenment {\n  padding: 0.16rem;\n  font-size: 0.15rem;\n  color: #1e283c;\n}\n#ServiceAgreenment h2 {\n  font-size: 0.18rem;\n}\n#ServiceAgreenment h3 {\n  margin: 0.05rem 0;\n  font-size: 0.15rem;\n}\n#ServiceAgreenment section {\n  margin: 0.12rem 0;\n}\n#ServiceAgreenment .dataTime {\n  text-align: right;\n  font-size: 0.12rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/serviceAgreenment2/index.less
// module id = 296
// module chunks = 0